import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from './AbstractMutableSet.mjs';
import { InternalHashMapmpvpylj0ut6l as InternalHashMap } from './InternalHashMap.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { KtMutableSetwuwn7k5m570a as KtMutableSet } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_collections_HashSet(_this__u8e3s4) {
}
var HashSetClass;
function HashSet() {
  if (HashSetClass === VOID) {
    class $ extends AbstractMutableSet() {
      static ga(map) {
        var $this = this.y7();
        init_kotlin_collections_HashSet($this);
        $this.w1_1 = map;
        return $this;
      }
      static ha() {
        return this.ga(InternalHashMap().y8());
      }
      static ia(elements) {
        var $this = this.ga(InternalHashMap().ja(elements.p1()));
        var _iterator__ex2g4s = elements.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          $this.w1_1.s3(element, true);
        }
        return $this;
      }
      static ka(initialCapacity, loadFactor) {
        return this.ga(InternalHashMap().a9(initialCapacity, loadFactor));
      }
      static x1(initialCapacity) {
        return this.ka(initialCapacity, 1.0);
      }
      v(element) {
        return this.w1_1.s3(element, true) == null;
      }
      v3() {
        this.w1_1.v3();
      }
      t1(element) {
        return this.w1_1.e9(element);
      }
      i1() {
        return this.w1_1.p1() === 0;
      }
      m1() {
        return this.w1_1.m9();
      }
      w3(element) {
        return !(this.w1_1.t3(element) == null);
      }
      p1() {
        return this.w1_1.p1();
      }
    }
    initMetadataForClass($, 'HashSet', $.ha, VOID, [AbstractMutableSet(), KtMutableSet()]);
    HashSetClass = $;
  }
  return HashSetClass;
}
//region block: exports
export {
  HashSet as HashSet2dzve9y63nf0v,
};
//endregion

//# sourceMappingURL=HashSet.mjs.map
